<template>
  <div class="home" :style="bannerFlag ? 'margin-top: 45px;':''">
    <div v-loading="loading" element-loading-text="加载中..." style="min-height: calc(100vh - 106px);" v-if="!error">
      <div class="banner w">
        <div class="bg" ref="bg" @mouseover="bgOver($refs.bg)" @mousemove="bgMove($refs.bg,$event)"
          @mouseout="bgOut($refs.bg)">
          <span>
            <h1>Online设计服务</h1>
          </span>
        </div>
      </div>
      <section class="activity-panel w">
        <ul class="box">
          <li class="content" v-for="(item,j) in catalogList" :key="j" @click="linkToCatalog(j)">
            <img class="i" :src="item.iconSelect">
            <span style="font-size: 22px;margin-top: -5px;">{{item.name}}</span>
            <a class="cover-link"></a>
          </li>
        </ul>
      </section>
      <section class="news-panel w">
        <div class="new-panel-box" id="home" @click="onAiDesign()">
          <img src="https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/match/aibg.png" style="height: 100%;width: 100%;">
          <!-- <p class="steamTitle">日照亚太数字口腔智能智造技术大奖赛</p> -->
         <!-- <a class="steamContent" @click="linkToNews(0)">大赛进程详情</a>
          <a class="steamUpload" @click="linkToNews(1)">作品提交入口</a> -->
        <!--  <el-button class="steamContent" @click="linkToNews(0)">大赛进程详情</el-button>
           <el-button class="steamUpload" @click="linkToNews(1)">作品提交入口</el-button> -->
          <!-- <h1>
            行业新闻
            <span>NEWS WEEKLY</span>
          </h1> -->
          <!-- <ul>
            <li v-for="(item, i) in poster" :key="i"
            style="display: block;color: black;">
              {{ item.label }}
            </li>
          </ul> -->
        </div>
        <!-- 活动提示 -->
        <!-- <div class="activity-tip" @click="linkToNews(1)"> -->
          <!-- <img src="/static/images/steamTip1.png" alt=""> -->
        <!-- </div> -->
      </section>
      <section class="mall-panel w" style="margin-top: 80px;">
        <div class="mall-panel-box">
          <ul class="left-box">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </section>

      <section class="link-panel w">
        <h1>服务专区</h1>
        <div class="link-box">
          <ul>
            <li v-for="(item,index) in cataList" :key="index">
              <div class="box-li" @click="openAgree(item.id)">
                <i :class="item.icon"></i>
              </div>
              <span>{{item.item}}</span>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <div class="no-info" v-if="error">
      <div class="no-data">
        <img src="/static/images/error.png">
        <br> 抱歉！出错了...
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="600px" center>
      <div slot="title" class="header-title">
        <div style="padding:15px 20px;">认证申请</div>
      </div>
      <!-- <div style=""> -->
      <div style="display: flex; align-items: center; justify-content:space-around;height: 300px;">
        <div class="item itme1">
          <a @click="factory">
            <div class="t fiex f-18">
              <div class="t2 center"><img src="/static/images/zc11.png">
                <!-- <p class="mag-t-20">认证诊所/工厂进行下单</p> -->
              </div>
            </div>
            <div class="p">诊所/工厂认证</div>
          </a>
        </div>
        <div class="item itme2">
          <a @click="designer">
            <div class="t fiex f-18">
              <div class="t2 center"><img src="/static/images/zc22.png">
                <!-- <p class="mag-t-20">认证成为设计师进行接单</p> -->
              </div>
            </div>
            <div class="p">设计师认证</div>
          </a>
        </div>
      </div>
      <!-- </div> -->
    </el-dialog>
    <Customer class="customerSer"></Customer>
    <tools class="tools" style="display: block;"></tools>
  </div>
</template>
<script>
  import bannerData from "/assets/config/home/banner.js";
  import catalogData from "/assets/config/order/catalogList.js";
  import goodsData from "/assets/config/goodsList.js";
  import mallGoods from '/components/mallGoods'
  import Customer from '../Order/components/customerSer.vue'
  import tools from '../Home/tools'
  import {
    setStore,
    getStore
  } from '/utils/storage.js'
  import {
    mapState
  } from 'vuex'

  export default {
    data() {
      return {
        loading: true,
        error: false,
        bannerFlag: false,
        bannerList: [],
        catalogList: [],
        goodsList: [],
        poster:[
          {label:'新技术'},
          {label:'新材料'},
          {label:'设备上新'},
          {label:'行业动向'},
          // {label:'赛事资讯'},
          // {label:'作品提交'},
        ],
        mark: 0,
        bgOpt: {
          px: 0,
          py: 0,
          w: 0,
          h: 0
        },
        timer: '',
        dialogVisible: false,
        cataList:[
          {item:'在线软件',icon:'el-icon-s-promotion',id:'23'},
          {item:'软件下载',icon:'el-icon-download',id:'24'},
          {item:'合作介绍',icon:'el-icon-monitor',id:'21'},
          {item:'医患沟通应用介绍',icon:'el-icon-document-copy',id:'25'},
          {item:'设计说明',icon:'el-icon-cpu',id:'12'},
          {item:'售后服务',icon:'el-icon-box',id:'13'},
          {item:'下单操作流程',icon:'el-icon-sold-out',id:'15'},
          {item:'接单操作流程',icon:'el-icon-sell',id:'16'},
          {item:'固定模块说明',icon:'el-icon-coin',id:'18'},
          {item:'种植模块说明',icon:'el-icon-price-tag',id:'17'},
          {item:'联系方式',icon:'el-icon-phone-outline',id:'31'},
          {item:'企业招聘',icon:'el-icon-user',id:'32'},
          {item:'荣誉奖项',icon:'el-icon-s-management',id:'33'},
          {item:'线上培训',icon:'el-icon-top',id:'34'},
          {item:'线下培训',icon:'el-icon-bottom',id:'35'},
          {item:'有关医小智',icon:'el-icon-reading',id:'41'},
          {item:'投诉与反馈',icon:'el-icon-edit-outline',id:'43'},
          {item:'在线客服',icon:'el-icon-headset',id:'44'},
        ],
        showTooltip: false,
        message: '这是一个指向 header 的提示窗口',
        showArrowUp: true,
      }
    },
    computed: {
      ...mapState(['user'])
    },
    methods: {
      linkToNews(index) {
        // 判断是否登陆/认证

        if (this.user.isLogin) {

          if (this.user.userType === '99' || this.user.authFlag == '99') {
            this.$yxz.msg('账号未认证或认证被驳回，请提交认证资料', 'error')

            if (this.user.authFlag == '00') {
              this.dialogVisible = true
              return false;
            }
            if (this.user.authFlag == '02') {
              this.dialogVisible = true
              return false;
            }
            if (this.user.authFlag == '99') {
              this.dialogVisible = true
              return false;
            }
          } else {
            if (this.user.authFlag == '02') {
              this.$message({
                message: '您的认证信息正在审核中，请稍后重试...',
                type: 'success'
              });
            } else {
              let url = index == 0 ? '/agreement?agreeId=45' : '/match/upload';
              // if(index==1){
              //   localStorage.setItem('matchUpload','/match/upload');
              // }else{
              //   localStorage.setItem('matchUpload','/agreement?agreeId=45');
              // }
              localStorage.setItem('matchUpload', url);
              let routeUrl = this.$router.resolve({ path: url });
              window.open(routeUrl.href, '_blank');
            }
          }
        } else {

          this.$yxz.msg('未登录或登录状态已过期,请重新登录', 'error')
          var that = this;
          setTimeout(function () {
            that.$yxz.to('/login')
          }, 1500);

        }

        let url = index == 0 ? '/agreement?agreeId=45' : '/match/upload';
        // if(index==1){
        //   localStorage.setItem('matchUpload','/match/upload');
        // }else{
        //   localStorage.setItem('matchUpload','/agreement?agreeId=45');
        // }
        localStorage.setItem('matchUpload',url);
        let routeUrl = this.$router.resolve({path: url});
        window.open(routeUrl.href, '_blank');
      },
      onAiDesign() {
        let routeUrl = this.$router.resolve({path: '/aides'});
        window.open(routeUrl.href, '_blank');
      },

      // 控制顶部
      navFixed() {
        if (this.$route.path === '/home') {
          var st = document.documentElement.scrollTop || document.body.scrollTop
          st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
        } else {
          return
        }
      },
      autoPlay() {
        this.mark++
        if (this.mark > this.bannerList.length - 1) {
          // 当遍历到最后一张图片置零
          this.mark = 0
        }
      },
      play() {
        // 每2.5s自动切换
        this.timer = setInterval(this.autoPlay, 5000)
      },
      change(i) {
        this.mark = i
      },
      startTimer() {
        this.timer = setInterval(this.autoPlay, 5000)
      },
      stopTimer() {
        clearInterval(this.timer)
      },
      linkTo(item) {
        // window.open('//' + window.location.host + '/#/home')
      },
      linkToCatalog(index) {
        if (this.user.isLogin) {

          if (this.user.userType === '99'||this.user.authFlag == '99') {
            this.$yxz.msg('账号未认证或认证被驳回，请提交认证资料', 'error')

            if (this.user.authFlag == '00') {
              this.dialogVisible = true
            }
            if (this.user.authFlag == '02') {
              this.dialogVisible = true
            }
            if (this.user.authFlag == '99') {
              this.dialogVisible = true
            }
          }else{
            if(this.user.authFlag == '02'){
              this.$message({
                message: '您的认证信息正在审核中，请稍后重试...',
                type: 'success'
              });
            }else{
              if (this.user.userType === '10') {
                window.open('//' + window.location.host + '/#/order/create?catalogId=' + index)
              }
              if (this.user.userType === '20') {
                window.open('//' + window.location.host + '/#/order/mall')
              }
            }
          }
        } else {

          this.$yxz.msg('未登录或登录状态已过期,请重新登录', 'error')
          var that = this;
          setTimeout(function() {
            that.$yxz.to('/login')
          }, 1500);

        }

      },
      bgOver(e) {
        this.bgOpt.px = e.offsetLeft
        this.bgOpt.py = e.offsetTop
        this.bgOpt.w = e.offsetWidth
        this.bgOpt.h = e.offsetHeight
      },
      bgMove(dom, eve) {
        let bgOpt = this.bgOpt
        let X, Y
        let mouseX = eve.pageX - bgOpt.px
        let mouseY = eve.pageY - bgOpt.py
        if (mouseX > bgOpt.w / 2) {
          X = mouseX - (bgOpt.w / 2)
        } else {
          X = mouseX - (bgOpt.w / 2)
        }
        if (mouseY > bgOpt.h / 2) {
          Y = bgOpt.h / 2 - mouseY
        } else {
          Y = bgOpt.h / 2 - mouseY
        }
        dom.style['transform'] = `rotateY(${X / 50}deg) rotateX(${Y / 50}deg)`
        dom.style.transform = `rotateY(${X / 50}deg) rotateX(${Y / 50}deg)`
      },
      bgOut(dom) {
        dom.style['transform'] = 'rotateY(0deg) rotateX(0deg)'
        dom.style.transform = 'rotateY(0deg) rotateX(0deg)'
      },
      designer() {
        this.$yxz.to('/designerAuth')
        this.dialogVisible = false
      },
      factory() {
        this.$yxz.to('/factoryAuth')
        this.dialogVisible = false
      },
      openAgree(id) {
        if(id==24){
         let routeUrl = this.$router.resolve({path: '/downLoad'})
         window.open(routeUrl.href, '_blank');
        }else{
          let url = this.$router.replace({
           name:'agreement',
           query: {agreeId:id},
          })
          window.open(url,'_self')
        }
      }
    },
    mounted() {
      this.navFixed()
      window.addEventListener('scroll', this.navFixed)
      window.addEventListener('resize', this.navFixed)
      this.$yxz.title("医小智 - 首页")
      if(localStorage.getItem('matchUpload')){
        let url = localStorage.getItem('matchUpload');
        localStorage.removeItem('matchUpload');
        this.$router.push(url);
      }
    },
    created() {
      this.bannerList = bannerData;
      this.goodsList = goodsData;
      this.catalogList = catalogData;
      this.loading = false;
      this.play()
    },
    components: {
      mallGoods,
      Customer,
      tools
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  .home {
    display: flex;
    flex-direction: column;
    // background-color: red;
    // background: url(/static/images/background.png) no-repeat;
    background: url(/static/images/square.png);
    // background-size :100%;
  }

  .no-info {
    padding: 100px 0;
    text-align: center;
    font-size: 30px;
    display: flex;
    flex-direction: column;

    .no-data {
      align-self: center;
    }

  }

  .banner,
  .banner span,
  .banner div {
    font-family: "Microsoft YaHei";
    transition: all .3s;
    transition-timing-function: linear;
  }

  .banner {
    cursor: pointer;
    perspective: 3000px;
    position: relative;
    z-index: 20;
    margin: 10px auto;

    .bg {
      position: relative;
      height: 170px;
      margin: 15px auto;
      background-size: 100% 100%;
      border-radius: 5px;
      transform-style: preserve-3d;
      transform-origin: 50% 50%;
      transform: rotateY(0deg) rotateX(0deg);
      // border: 1px solid #ccc;
      span{
          position: absolute;
          top: 40%;
          left: 42.5%;
        h1{
          font-size: 25px;
          // color: #0070c0;
          // font-weight: 600;
          // color: black;
          background-image: url(/static/images/goods4.jpeg);
          -webkit-background-clip: text;
          // color: #386FFA;
          color: black;
          background-color: white;
        }
      }

      & div {
        position: relative;
        height: 100%;
        width: 100%;
      }

      & img {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        border-radius: 5px;
      }
    }

    .page {
      position: absolute;
      width: 100%;
      // top: 180px;
      bottom: 15px;
      z-index: 30;

      .dots {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .dot-active {
          display: inline-block;
          width: 8px;
          height: 8px;
          background-color: whitesmoke;
          border-radius: 5px;
          margin-right: 10px;
          cursor: pointer;
        }

        .dot {
          opacity: 0.3;
        }
      }
    }
  }

  .activity-panel {
    margin: 10px auto;
    margin-bottom: 80px;
    .box {
      overflow: hidden;
      position: relative;
      z-index: 0;
    }

    .content {
      float: left;
      position: relative;
      box-sizing: border-box;
      width: 25%;
      height: 160px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .1);
      border-radius: 5px;
      // border: 1px solid rgba(0, 0, 0, .05);
      span{
        font-size: 17px;
      }
    }

    .content ::before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      box-sizing: border-box;
      // border: 1px solid rgba(0, 0, 0, .05);
      border-radius: 5px;
      // border-right: 1px solid rgba(0, 0, 0, .1);
      width: 100%;
      height: 100%;
      content: "";
      pointer-events: none;
    }

    .i {
      width: 170px;
      height: 110px;
      // background: rgba(0, 0, 0, .05)
    }

    .cover-link {
      cursor: pointer;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 4;
      background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
      border-radius: 5px;
    }

    a {
      cursor: pointer;
      transition: all .15s ease-out;
      text-decoration: none;
      box-shadow: inset 0 0 38px rgba(0, 183, 237, .23);
    }

    a:hover {
      // box-shadow: inset 0 0 38px rgba(0, 0, 0, .18);
      box-shadow: inset 0 0 38px rgba(0, 183, 237, .23);
      transition: all .55s ease;
    }

    span {
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      color: #00a5d5;
    }
  }

  .mall-panel {
    flex: 1;
    margin: 15px auto;
    margin-bottom: 80px;
    position: relative;
    overflow: hidden;
    border-radius: 5px;
    box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .1);
  }

  .news-panel {
    flex: 1;
    margin: 10px auto;
    position: relative;
    // overflow: hidden;
    background: #fff;
    border-radius: 5px;
    border-color: rgba(0, 0, 0, .14);
    box-shadow: 0 3px 8px -6px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    .new-panel-box{
      height: 260px;
      // background-color: rgba(#ffc56f ,1) ;
      // .steamTitle{
      //   position: absolute;
      //   top: 30%;
      //   left: 27%;
      //   color: white;
      //   font-size: 37px;
      //   font-weight: 550;
      // }
      .steamContent,.steamUpload{
        position: absolute;
        top: 70%;
        color: white;
        font-size: 25px;
        background-color:transparent;
        &:hover{
          text-decoration: underline;
        }
      }
      .steamContent{
        // left: 4.5%;
        left: 30%;
      }
      .steamUpload{
        // left: 25%;
        left: 50%;
      }
      h1{
        width: 61%;
        color: white;
        font-size: 45px;
        font-weight: 700;
        margin: 8% 0 0 10%;
        float: left;
        display: block;
        cursor: pointer;
        z-index: 99;
        span{
           font-size: 30px;
           margin-left: 7.5%;
        }
      }
      a{
        font-size: 35px;
        color: white;
      }
      ul{
        margin: 3% 19% 0 0;
        float: right;
        display: block;
      }
      li{
        font-size: 20px;
        margin: 15px;
        color: white;
      }
    }
  }

  .floors {

    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .img-banner {
      width: 50%;
      height: 380px;

      .cover-link {
        cursor: pointer;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 380px;
        z-index: 4;
        background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
      }

      // .cover-link:hover {
      //   box-shadow: inset 0 0 38px rgba(0, 0, 0, 0.18);
      //   transition: all .15s ease;
      // }
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .header-title {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    background-color: #0ca9d2;
    color: #fff;
    font-size: 22px;
    font-weight: 600;
  }

  .item .p {
    background: #f56521;
    padding: 12px;
    text-align: center;
    border-radius: 10px;
    color: #fff;
  }

  .item.itme2 .p {
    background: #0ca9d2;
  }

  .mall-panel-box{
    width: 100%;
    height: 300px;
    float: left;
    margin-bottom: 10px;
    // border: 1px solid powderblue;
  }

  .mall-panel-box .left-box{
    width: 100%;
    height: 100%;
    float: left;
    // border: 1px solid red;
  }

  .mall-panel-box .left-box li{
    width: 32.8%;
    height: 50%;
    float: left;
    margin: 0 0.5% 0.5% 0%;
    // border: 1px solid red;
    &:hover {
      transform: translateY(-3px);
      border-radius: 30px;
    }
  }
  .left-box li:nth-of-type(1){
    background: url(/static/images/AIDSD.png);
    background-size: 100% 100%;
    &:hover {
    box-shadow: 1px 1px 10px #24d1bc;
    }
  }
  .left-box li:nth-of-type(2){
    background: url(/static/images/AIISD.png);
    background-size: 100% 100%;
    &:hover {
    box-shadow: 1px 1px 10px #ff5459;
    }
  }
  .left-box li:nth-of-type(3){
    background: url(/static/images/mall.png);
    background-size: 100% 100%;
    &:hover {
    box-shadow: 1px 1px 10px #3971ff;
    }
  }
  .left-box li:nth-of-type(4){
    background: url(/static/images/ORTHO.png);
    background-size: 100% 100%;
    &:hover {
    box-shadow: 1px 1px 10px #9bd423;
    }
  }
  .left-box li:nth-of-type(5){
    background: url(/static/images/SHOWCASE.png);
    background-size: 100% 100%;
    &:hover {
    box-shadow: 1px 1px 20px #e1f7d2;
    }
  }
  .left-box li:nth-of-type(6){
    background: url(/static/images/service.png);
    background-size: 100% 100%;
    &:hover {
    box-shadow: 1px 1px 10px #00bd56;
    }
  }
  .link-panel{
    flex: 1;
    height: 400px;
    margin: 80px auto;
    margin-bottom: 90px;
    position: relative;
    overflow: hidden;
    border-radius: 5px;
    box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .1);
    h1{
      font-size: 28px;
      text-align: center;
      margin-top: 20px;
    }
  }
  .link-box{
    width: 100%;
    height: 100%;
    margin-top: 40px;
    // border: 1px solid #00bd56;
    li{
      float: left;
      margin-top: 2%;
      // margin-right: 8%;
      margin-right: 1.89%;
      display: block;
    }
  }
  .link-box ul li:nth-of-type(9),.link-box ul li:nth-of-type(18){
    margin-right: 0;
  }
  .box-li{
    width: 90px;
    height: 90px;
    border-radius: 50%;
    box-shadow: 6px -8px 8px -1px rgba(0,0,0,.1);
    border: 1px solid rgba(255,255, 255, .1);
	margin: 0 auto;
    &:hover{
      border: 1px solid #669aff;
      transform: translateY(-3px);
      transition: .5s;
    }
    i{
      font-size: 50px;
      color:#70a1ff;
      display: block;
      text-align: center;
      margin-top: 20%;
    }
  }
  .box-li+span{
    width: 115px;
    margin-top: 10px;
    display: block;
    text-align: center;
  }
  .tools{
    position: fixed;
    top: 100px;
    right: 50px;
    z-index: 999;
  }
// .activity-tip{
//   width: 300px;
//   height: 110px;
//   border-radius: 10px;
//   position: absolute;
//   top: -30%;
//   left: -23%;
//   img{
//     width: 250px;
//     height: 80px;
//   }
//   &:hover{
//     cursor: pointer;
//   }
// }
.matchContent{
  // margin: 15px;
  // color: #2c3e50;
  // font-size: 15px;
  position: relative;
}
.joinIcon{
  font-size: 40px;
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 5px;
  right: -5px;
}

.uploadButton{
  border-radius: 30px;
  border: 1px solid black;
  width: 230px;
  height: 50px;
  position: absolute;
  top: 55%;
  left: 40%;
  font-size: 25px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  background-color: transparent; /* 可以根据需要调整背景颜色 */
  color: black; /* 可以根据需要调整文字颜色 */
  transition: background-color 0.3s ease, color 0.3s ease; /* 添加过渡效果 */
}
.uploadButton:hover{
  // background-color: rgba(#FC5531,0.2); /* 鼠标悬停时的背景颜色 */
  background-color: rgba(white,0.2); /* 鼠标悬停时的背景颜色 */
  color: #00a4d4; /* 鼠标悬停时的文字颜色 */
}
.el-icon-bottom-right{
  padding: 5px;
  border-radius: 5px;
  transition: 1.3s ease, color 1.3s ease; /* 添加过渡效果 */
}
.el-icon-bottom-right:hover{
  border: 1px solid #00a4d4;
}
</style>



// WEBPACK FOOTER //
// home.vue?9b0f93a6